import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clientCurrentRegionSelector, clientProfileDataSliceSelector } from 'redux/selectors';
import { currentDivisionDataSelector } from 'redux/selectors/app';
import { setDivisionSettings } from 'redux/actions/app';
import { RegionsToDivisionTypeMap, DivisionTypeDictionary, DivisionType, HostnamesToDivisionTypesMap, DivisionSetting, getRegionByHostName, DivisionDomain } from 'common/model/client/divisionType';
import { Regions } from 'common/model/account/regions';
import { DivisionFavLogoDictionary } from '../../model/common';
import { useTheme } from '../themeProvider';
import { clientRegionsSlice } from 'redux/reducers/client/regions';

export const CurrentDivisionService: React.FC = () => {
    const dispatch = useDispatch();
    const { domain } = useTheme();
    const currentRegion = useSelector(clientCurrentRegionSelector);
    const userProfile = useSelector(clientProfileDataSliceSelector);
    const previewRegion = useRef(currentRegion);
    const currentDivision = useSelector(currentDivisionDataSelector);
    const favicon: HTMLElement | null = document.getElementById('favicon');
    const prevDomain = useRef(domain);

    const initializeDivisionAndRegion = useCallback((divisionSettings: DivisionSetting, region?: Regions) => {
        favicon?.setAttribute('href', DivisionFavLogoDictionary[divisionSettings.type]);
        dispatch(setDivisionSettings(divisionSettings));
        if (region) {
            dispatch(clientRegionsSlice.actions.setCurrentClientRegion((region as unknown) as string));
        }
    }, [dispatch, favicon]);

    useEffect(() => {
        let divisionType: DivisionType | null = null;
        if (!userProfile?.id && !!HostnamesToDivisionTypesMap[domain]) {
            previewRegion.current = currentRegion;
            prevDomain.current = domain;
            divisionType = HostnamesToDivisionTypesMap[domain];
            const divisionSettings = DivisionTypeDictionary[
                divisionType && divisionType in DivisionTypeDictionary ? divisionType : DivisionType.Vostok
            ];

            initializeDivisionAndRegion(divisionSettings, getRegionByHostName(divisionSettings.domainURL as unknown as DivisionDomain));
        }
        else if (
            !!userProfile?.id ||
            !currentDivision ||
            previewRegion.current !== currentRegion ||
            prevDomain.current !== domain) {
            previewRegion.current = currentRegion;
            prevDomain.current = domain;
            if (currentRegion) {
                divisionType = RegionsToDivisionTypeMap[currentRegion as Regions];
            }
            divisionType = divisionType && divisionType in DivisionTypeDictionary ? divisionType : DivisionType.Vostok;

            const divisionSettings = DivisionTypeDictionary[
                divisionType && divisionType in DivisionTypeDictionary ? divisionType : DivisionType.Vostok
            ];
            initializeDivisionAndRegion(divisionSettings);
        }
    }, [dispatch, currentDivision, favicon, currentRegion, domain, initializeDivisionAndRegion, userProfile?.id, userProfile]);

    return null;
};
